module.exports = __webpack_public_path__ + "static/media/darren-taylor.88bdbc16.jpg";